"use client";

import * as Sentry from "@sentry/nextjs";
import NextError from "next/error";
import { useEffect } from "react";

export default function GlobalError({
    error,
}: {
    error: Error & { digest?: string };
}) {
    useEffect(() => {
        console.error("Global error:", error);
        Sentry.captureException(error);
    }, [error]);

    return (
        <html lang="de">
            <body>
                {/* This is the default Next.js error component but it doesn't allow omitting the statusCode property yet. */}
                {/* biome-ignore lint/suspicious/noExplicitAny: <explanation> */}
                <NextError statusCode={undefined as any} />
            </body>
        </html>
    );
}
